import React, { Component } from 'react';
import 'ASSET/less/main.less';
import 'ASSET/less/app.less';
import 'ASSET/less/certification.less';
import 'ASSET/less/agreement.less';
import 'ASSET/less/activity.less';
import PropTypes from 'prop-types';
import Utility from 'UTIL/utility';
var Intl = require('intl');
import { LocaleProvider } from 'antd-mobile'; // antd国际化
import enUS from 'antd-mobile/lib/locale-provider/en_US';


//上面为antd组件的国际化，以下配置为本地页面标签的国际化
import { IntlProvider } from 'react-intl'; /* react-intl imports */
import localZhCN from 'RESOURCE/zh.cn';     // import defined messages in Chinese
import localEnUS from 'RESOURCE/en.us';    // import defined messages in English
import localPtPT from 'RESOURCE/pt.pt';    // import defined messages in Portuguese
import localFrFr from 'RESOURCE/fr.fr'; 

import fingerPrint from 'UTIL/fingerPrint';

// import common from 'ACTION/common/commonAction';
// import { bindActionCreators } from 'redux';
// import { connect } from 'react-redux';
//
// const mapDispatchToProps = dispatch => ({
//   common: bindActionCreators(common, dispatch),
// });
//
// @connect(
//   ({ common }) => ({ common }),
//   mapDispatchToProps,
// )
class Frame extends Component {
  // 父组件声明自己支持 context
  static childContextTypes = {
    callback: PropTypes.func,
  };

  constructor(props) {
    super(props);
    let searchParams = Utility.getSearchParams();
    if(searchParams.language) {
      sessionStorage.setItem('LANG', searchParams.language);
    } else {
      searchParams.language = 'zh';
    }
    this.state = {
      backUrl: '',
      leftStyle: {},
      locale: searchParams.language == undefined ? 'zh-cn' : enUS, // antd
      localLang: localZhCN, //本地
      localLocale: 'pt'
    };
  }

  // 父组件提供一个函数，用来返回相应的 context 对象
  getChildContext() {
    return {
      callback: this.callback.bind(this),
    };
  }

  componentWillMount() {
   
    // // 获取登录token 各种token同步放入
    // const tmpObj = Utility.getSearchParams();
    // if (tmpObj && tmpObj.ssoToken) {
    //   Utility.User.setUser({
    //     ssoToken: tmpObj.ssoToken,
    //   });
    // }
    // if (tmpObj && tmpObj.userToken) {
    //   Utility.User.setUser({
    //     userToken: tmpObj.userToken,
    //   });
    // }
    // if (tmpObj && tmpObj.kjtToken) {
    //   Utility.User.setUserInfoDevice({
    //     kjtToken: tmpObj.kjtToken,
    //     deviceId: tmpObj.deviceId,
    //     deviceType: tmpObj.deviceType,
    //   });
    // }

    // 初始化设备指纹
    fingerPrint.init();
    //判断链接是否带语言
       //初始化本地语言
       //this.changeLocale(sessionStorage.getItem('LANG') || navigator.language.split('_')[0]);
       this.changeLocale(Utility.getLang());
  }

  componentDidMount() {
 
  }

  // 返回键
  backTo = () => {
    if (this.state.leftStyle.display === 'block') {
      if (this.state.backUrl !== '') {
        window.location.href = this.state.backUrl;
      } else {
        window.history.go(-1);
      }
    }
  };

  callback(_url, _leftDisplay) {
    this.setState({
      backUrl: _url,
      leftStyle: {
        display: _leftDisplay,
      },
    });
  }
   
  //自动识别浏览器语言
  changeLocale = (lang) => {
    
    sessionStorage.setItem('LANG', lang.toLowerCase());
    switch(lang.toLowerCase()) {
        case 'en-us':
            this.setState({localLocale: 'en', localLang: localEnUS, locale: enUS});
            break;
        case 'en':
            this.setState({localLocale: 'en', localLang: localEnUS, locale: enUS});
            break;
        case 'zh-cn':
            this.setState({localLocale: 'zh', localLang: localZhCN, locale: undefined});
            break;
        case 'zh':
            this.setState({localLocale: 'zh', localLang: localZhCN, locale: undefined});
            break;
        case 'pt-pt':
            this.setState({localLocale: 'pt', localLang: localPtPT, locale: enUS});
            break;
        case 'pt':
            this.setState({localLocale: 'pt', localLang: localPtPT, locale: enUS});
            break;
        case 'fr':
            this.setState({localLocale: 'fr', localLang: localFrFr, locale: enUS});
            break;
        default:
            this.setState({localLocale: 'pt', localLang: localPtPT, locale: enUS});
            break;
    }
}

  render() {
    return  (
          <IntlProvider 
             locale={this.state.localLocale} 
             messages={this.state.localLang}
            >
              <LocaleProvider locale={this.state.locale}>
               <div className="page-body">{this.props.children}</div>
              </LocaleProvider>
          </IntlProvider>
    );
  }
}

export default Frame;



// WEBPACK FOOTER //
// ./src/view/frame.js